import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { spatemsAdapter } from './spatemsReducers';

const spatemsStateDomain = (state: RootState) => state.spatems;

export const loadingSelector = createSelector(
  spatemsStateDomain,
  (spatem) => spatem.loading,
);

export const spatemsSelector = createSelector(spatemsStateDomain, (spatem) =>
  spatemsAdapter
    .getSelectors()
    .selectAll(spatem)
    .slice()
    .sort((a, b) => {
      const nameA = a.name || '';
      const nameB = b.name || '';
      return nameA.localeCompare(nameB);
    }),
);

// Selector to get a single spatem by id
export const spatemByIdSelector = (id: string) =>
  createSelector(spatemsStateDomain, (spatem) =>
    spatemsAdapter.getSelectors().selectById(spatem, id),
  );

